import * as API from "@/services/API";

export default {
    getTips() {
        return API.apiClient.get("/admin-dashboard/parent-tips");
    },
    createTip(data) {
        return API.apiClient.post("/admin-dashboard/parent-tips", data);
    },
    updateTip(id, data) {
        return API.apiClient.put(`/admin-dashboard/parent-tips/${id}`, data);
    },
};
